import { render, staticRenderFns } from "./PorcentagemDevolucao.vue?vue&type=template&id=4dcfae14&scoped=true&"
import script from "./PorcentagemDevolucao.vue?vue&type=script&lang=js&"
export * from "./PorcentagemDevolucao.vue?vue&type=script&lang=js&"
import style0 from "./PorcentagemDevolucao.vue?vue&type=style&index=0&id=4dcfae14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcfae14",
  null
  
)

export default component.exports